/**
 * This component is used to set the document title.
 * It is a wrapper around the title element that
 * sets the document title to the given title.
 *
 * @param {Object} props - The props object.
 * @param {string} props.title - The title to set.
 * @param {string} props.pattern - The pattern to use for the title.
 * @returns {React.ReactElement} The document title element.
 */
const DocumentTitle = ({
    title = 'Buy Now, Pay Later, Build Credit',
    pattern = 'Perpay | %s',
}) => (
    // This condition is set to prevent a null title from being displayed
    <title>{title ? pattern.replace('%s', title) : 'Perpay'}</title>
);

export default DocumentTitle;
